import React from 'react';
import PropTypes from 'prop-types';

// Components
import { TextInput } from 'components/forms/form-elements';
import HelpText from './help-text';


// This is a component used to display the ticket help text only
// when the ticket description field is active
export default class TicketDescription extends React.Component { // eslint-disable-line react/prefer-stateless-function
  static propTypes = {
    meta: PropTypes.object.isRequired, // Prop from redux-form Field
    placement: PropTypes.string
  };

  render() {
    const { meta, placement, ...props } = this.props;
    
    return (
      <div>
        <TextInput {...props} meta={meta} />
        <HelpText show={meta.active} container={this} placement={placement}>
          <p>Ticket descriptions are <span className="emphasize">seen by clients</span>.
          Include reporter, affected parties and a concise problem description.</p>
          <div className="examples">
            <p>"Jane reports John's Skype contacts are missing pictures"</p>
            <p>"Jane not able to log into Quickbooks"</p>
          </div>
        </HelpText>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/forms/help-text/ticket-description-input.js